import { useMutation } from '@tanstack/react-query';
import {
  DEMO_FILL_JSON_FORM_FROM_UPLOAD_MUTATION_KEY,
  type FillJsonFormDemoFromUploadRequest,
  type FillJsonFormDemoResponse,
} from '../../contracts';
import { fillJsonFormDemoFromUpload } from '../api/templates';

export function useMutateFillJsonFormDemoFromUpload() {
  return useMutation<FillJsonFormDemoResponse, Error, FillJsonFormDemoFromUploadRequest>({
    mutationKey: DEMO_FILL_JSON_FORM_FROM_UPLOAD_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillJsonFormDemoFromUpload(request);
      return data;
    },
  });
}
